import { ChainId } from '@nominex/nomiswap-sdk'
import EthereumPools from './1'
import OptimismPools from './10'
import BscPools from './56'
import GnosisPools from './100'
import PolygonPools from './137'
import ArbitrumPools from './42161'
import AvalanchePools from './43114'
import { SerializedPoolConfig } from './types'

export const getPoolsConfig = (chainId: ChainId): SerializedPoolConfig[] => {
  switch (chainId) {
    case ChainId.BSC:
      return BscPools
    case ChainId.ETHEREUM:
      return EthereumPools
    case ChainId.MATIC:
      return PolygonPools
    case ChainId.OPTIMISM:
      return OptimismPools
    case ChainId.GNOSIS:
      return GnosisPools
    case ChainId.ARBITRUM:
      return ArbitrumPools
    case ChainId.AVALANCHE:
      return AvalanchePools
    default:
      return []
  }
}

export * from './constants'
export * from './helpers'
export * from './types'
